import { render, staticRenderFns } from "./CardSaborPizzaCarrinho.vue?vue&type=template&id=184f4866&scoped=true&"
import script from "./CardSaborPizzaCarrinho.vue?vue&type=script&lang=js&"
export * from "./CardSaborPizzaCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./CardSaborPizzaCarrinho.vue?vue&type=style&index=0&id=184f4866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f4866",
  null
  
)

export default component.exports